import React, { useMemo, useRef } from 'react';
import { css } from '@emotion/react';
import { ModalContent, ResponsiveSidebarDialog } from '@/styles/blocks';
import { Grid } from '@material-ui/core';
import GoogleMap from '@/components/GoogleMap';
import { DropOff } from '@/components/DispatchPlan/map/MapMarkers';

const MapModal = ({ waypoints, callbacks }) => {
    const mapRef = useRef();

    const open = useMemo(() => {
        return !!waypoints?.length;
    }, [waypoints]);

    return (
        <ResponsiveSidebarDialog open={open} onClose={callbacks.onClose}>
            <ModalContent
                css={css`
                    width: 100%;
                `}
            >
                <Grid container direction="column">
                    <Grid
                        item
                        css={css`
                            width: 700px;
                            height: 350px;
                        `}
                    >
                        <GoogleMap
                            ref={mapRef}
                            zoom={15}
                            draggableCursor="pointer"
                            gestureHandling="greedy"
                            center={waypoints?.[0]}
                        >
                            {(waypoints || []).map((waypoint) => (
                                <DropOff key={`marker-${waypoint.lat}-${waypoint.lng}`} position={waypoint} />
                            ))}
                        </GoogleMap>
                    </Grid>
                </Grid>
            </ModalContent>
        </ResponsiveSidebarDialog>
    );
};

export default MapModal;
